import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyFeedAdditive, getFootprintingDairyFeedAdditiveAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_FEED_ADDITIVE } from "consts";

export const useGetFootprintingDairyFeedAdditive = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;

  return useQuery({
    queryKey: [FOOTPRINTING_DAIRY_FEED_ADDITIVE, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getFootprintingDairyFeedAdditiveAdmin(primaryDataId ?? "") : getFootprintingDairyFeedAdditive(primaryDataId ?? "")),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
